import { useQuery } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const fetchIntegrationLogs = (data) => {
  return axios.get(`${apiurl?.getIntegrationLogList}?PoNumber=${data?.poNumber}&Page=${data?.Page}&PageSize=${data?.PageSize}`);
};

const fetchIntegrationLog = (data) => {
  return useQuery(['getIntegrationLogList', data], () => fetchIntegrationLogs(data), { refetchOnWindowFocus: false });
};

export default fetchIntegrationLog;
